import { InjectionToken } from '@angular/core';

export let APP_CONFIG = new InjectionToken('app.config');

export interface IAppConfig {
  env: any;
  panels: any;
  tpaPanels: any;
}

export const AppConfig: IAppConfig = {
  env: {
    'ngeum-ui-dev': 'dev',
    'ncegcolnx158': 'dev',
    'blrrndobedev88.rnd.amadeus.net': 'dev',
    'www.office-management.amadeus.com': 'prd',
    'office-management.amadeus.com': 'prd',
    'dev.office-management.amadeus.com': 'dev',
    'www.dev.office-management.amadeus.com': 'dev',
    'pdt.office-management.amadeus.com': 'pdt',
    'uat.office-management.amadeus.com': 'uat',
    'mig.office-management.amadeus.com': 'mig',
    'fvt.office-management.amadeus.com': 'fvt',
    'btprd.office-management.amadeus.com': 'btprd',
    'ppt.office-management.amadeus.com': 'ppt',
    'skl.office-management.amadeus.com': 'skl',
    '171.17.128.203': 'dev'
  },
  panels: [
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
    'R'
  ],
  tpaPanels: ['P', 'Q', 'T', 'W', 'Z']
};
